import React from 'react';
import Svg from '../Svg';

const IconCloudSun03 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 3C6.91015 3 4 5.91015 4 9.5C4 9.94651 4.04487 10.3815 4.13004 10.8011C4.23991 11.3423 3.89021 11.8701 3.34896 11.98C2.80771 12.0899 2.27988 11.7402 2.17001 11.1989C2.05842 10.6492 2 10.0809 2 9.5C2 4.80558 5.80558 1 10.5 1C14.811 1 18.3709 4.20834 18.9252 8.36793C18.9981 8.91538 18.6134 9.4183 18.066 9.49124C17.5185 9.56418 17.0156 9.17952 16.9427 8.63207C16.5191 5.45295 13.7952 3 10.5 3ZM12 11C9.82019 11 7.96373 12.3955 7.28016 14.3449C7.12946 14.7746 6.70737 15.0483 6.25349 15.0105C6.17013 15.0036 6.08559 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21H17.5C19.433 21 21 19.433 21 17.5C21 15.567 19.433 14 17.5 14C17.4219 14 17.3445 14.0025 17.2679 14.0075C16.8877 14.0323 16.5265 13.8389 16.3363 13.5088C15.4715 12.0072 13.8528 11 12 11ZM5.66881 13.0108C6.78961 10.641 9.20208 9 12 9C14.3824 9 16.4857 10.1906 17.749 12.0055C20.671 12.1357 23 14.5459 23 17.5C23 20.5376 20.5376 23 17.5 23H6C3.23858 23 1 20.7614 1 18C1 15.3499 3.06179 13.1813 5.66881 13.0108Z"
    />
  </Svg>
);

export default IconCloudSun03;
